import axios from '../utils/auth';

const getAlbums = () => {
    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    return axios().get("gallery/albums" + "?currentLang=" + currentLang);
}
const getGallerybyAlbum = (album_id) => {
    let currentLang = localStorage.getItem('activeLanguage') ? localStorage.getItem('activeLanguage') : 'en';
    return axios().get("gallery/albums/" + album_id + "?currentLang=" + currentLang);
}

const galleryService = {
    getAlbums,
    getGallerybyAlbum
};

export default galleryService;
